import { ReactComponent as EditIconSVG } from '../../../assets/images/icons/OrangePencil.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const EditIcon = (props: any) => {
	return (
		<SvgIcon {...props}>
			<EditIconSVG />
		</SvgIcon>
	);
};

export default EditIcon;